export default {
  // Map
  search: 'Search',
  settings: 'Settings',
  // Welcome
  skip: 'Skip',
  welcomeGeoTxt: 'Atlastories uses your geolocation to discover nearby places history',
  welcomeGeoBtn: 'Enable geolocation',
  welcomeUxTxt: 'Connect your headphones and prevent sleep mode for a better experience',
  welcomeUxBtn: 'Prevent sleep mode',
  welcomeGtuTxt: 'We use analytics and track errors to make this application better',
  welcomeGtuBtn: 'Read the terms of use',
  // Gtu
  agree: 'Agree',
  termsTitle: 'General terms of use',
  // Settings
  settingsTitle: 'Settings',
  settingsLang: 'Language',
  settingsMap: 'Map style',
  settingsGps: 'Satellite signal',
  settingsCache: 'Cache images',
  settingsNosleep: 'No sleep',
  settingsNosleepEnabled: 'The phone will never sleep',
  settingsNosleepDisabled: 'Inactivity turn of the screen',
  settingsKm: 'Metric system',
  settingsDark: 'Dark mode',
  settingsTerms: 'Terms of use',
  settingsCacheFooter: 'Cache images: XX day(s)',
  settingsGpsFooter: 'Precision: ',
  settingsKmFooter: 'Distance unit: ',
  enabled: 'Enabled',
  disabled: 'Disabled',
  version: 'Version',
  // SettingsMap
  settingsMapTitle: 'Map styles',
  tilesbasic: 'Classic',
  tilesbright: 'Bright',
  tilesdarkmatter: 'Dark',
  tilespastel: 'Pastel',
  tilestopo: 'Topo',
  tilespositron: 'Grey',
  tileshybrid: 'Satellite',
  tilesstreets: 'Streets',
  tilesvoyager: 'Voyager',
  // SettingsLang
  settingsLangTitle: 'Langages'
}
